import axios from 'axios'
import router from '../router'
import store from '@/store'
import {
  Loading
} from 'element-ui';
import {
  Message
} from 'element-ui';
/**
 * 请求拦截器
 * 
 */
axios.interceptors.request.use(config => { //在此处统一配置公共参数

  config => {
      var token = store.state.oidcStore.access_token; //oidc
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}` // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return config
    },
    error => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
    }
  //  let appId = process.env.appId; //appid
  //  let appKey = process.env.appKey; //appkey
  //  let sessionKey = localStorage.getItem('sessionKey'); //sessionkey
  //  let _site_id_param = localStorage.getItem('_site_id_param')|| '';//站点id
  //  let params = {
  //      appId: appId,//appid
  //      nonce_str: getRand(),//随机数
  //      _site_id_param: _site_id_param
  //  };
  //  if (sessionKey && sessionKey != '') {
  //      params.sessionKey = sessionKey;
  //  }
  //  for (let key in config.data) {
  //      params[key] = config.data[key]; //添加进参数列表
  //  }
  //  params = signParams(params, appKey);//返回签名后的对象
  //  config.data = qs.stringify(params);//序列化
  return config;
}, error => {

  Promise.reject(error); // 错误提示
})


/**响应拦截器 */
axios.interceptors.response.use(response => {
    //  let res = response.data;
    //  switch (res.code) {
    //      case '200':

    //          break;
    //      case '301':

    //          break;
    //      case '304':

    //          break;
    //      case '3':
    //          showMessage(res.code + ":" + res.message);
    //          localStorage.setItem('sessionKey', '');
    //          localStorage.setItem('userName', '');
    //          router.push('/login');
    //          break;
    //      case '302':
    //          showMessage(res.code + ":" + res.message);
    //          localStorage.setItem('sessionKey', '');
    //          localStorage.setItem('userName', '');
    //          router.push('/login');
    //          break;
    //      default:
    //          showMessage(res.code + ":" + res.message);
    //          break;
    //  }
    return response;
  },
  error => {
    //   showMessage('服务器响应失败');
    return Promise.reject(error.response)
  }
);
const handleCommonResult = (res) => { //正常业务结果
  if (res.data.statusCode === 200) return res.data.result;
  else {
    if (res.data.hasOwnProperty('message'))
      Message.error({
        showClose: true,
        message: res.data.message
      });
    else if (res.data.hasOwnProperty('result')) {
      Message.error({
        showClose: true,
        message: JSON.stringify(res.data.result)
      });
    }
    throw res.data;
  }
}
const handleResult = (res) => {
  if (res.status == 200 || res.status == 201) {
    if (res.data && res.data.hasOwnProperty('statusCode')) return handleCommonResult(res);
    else return res.data;
  } else if (res.status == 500) {
    if (res.data && res.data.hasOwnProperty('statusCode')) return handleCommonResult(res);
  }

  if (res.status === 401) {
    Message.error({
      showClose: true,
      message: "登录信息已失效"
    })
  } else if (res.status === 403) {
    Message.error({
      showClose: true,
      message: "您无权限访问！"
    })
  } else if (res.status === 404) {
    Message.error({
      showClose: true,
      message: "请求接口地址不存在，请检查！"
    })
  } else if (res.status === 400) {
    if (res.data && res.data.hasOwnProperty('errors') && res.data.errors) {
      let errors = res.data.errors;
      let keys = Object.keys(errors);
      Message.error({
        showClose: true,
        message: errors[keys[0]]
      });
    }
  } else {
    Message.error({
      showClose: true,
      message: "网络异常！"
    })
  }
  throw res
}

const format_object = (body) => { //处理post数据
  body = {
    ...body
  };
  Object.keys(body).forEach(key => {
    if (Object.prototype.toString.call(body[key]) === "[object String]") {
      body[key] = body[key].trim();
    }
    // else if (Object.prototype.toString.call(body[key]) === "[object Date]") {
    //     body[key] = body[key].Format('yyyy/MM/dd');
    // }
  });
  return body;
}

var nocache = {
  'X-Requested-With': 'XMLHttpRequest',
  'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache'
}
var baseUrl = process.env.VUE_APP_PROMISSION_API
var http = {
  header: {
    get Authorization() {
      var token = store.state.oidcStore.access_token; //oidc
      if (token) {
        return `Bearer ${token}` // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return this._token;
    },
    set Authorization(value) {
      localStorage.removeItem('_token')
      if (value) {
        localStorage.setItem("_token", value);
      }
      this._token = value;
    }
  },
  setheader(token) {
    if (token) this.header.Authorization = "Bearer " + token;
    else this.header.Authorization = null;
  },
  async get(url, params, config) {
    if (!config || !config.headers) config = {
      headers: this.header
    };
    if(!config.params){
        config.params = params
    }
    this.block();
    const res = await axios.get(baseUrl + url, config).catch(res => res);
    this.unblock();
    return handleResult(res);

  },
  async post(url, data, config) {
    if (data && Object.prototype.toString.call(data) === '[object Object]') data = format_object(data); //处理post数据 去空
    this.block();
    if (!config) config = {
      headers: this.header
    };
    const res = await axios.post(baseUrl + url, data, config).catch(res => res);
    this.unblock();
    return handleResult(res);
  },
  count: 0,
  loading: null,
  /** block ui */
  block() {
    this.count = this.count + 1;
    if (this.count != 1) return;
    this.loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.0)'
    });
  },
  /** unblock */
  unblock() {
    this.count = this.count - 1;
    if (this.count < 0) this.count = 0;
    if (this.count) return;
    this.loading.close();
  },
  async awaitTasks(tasks) {
    if (!tasks) return;
    var result = [];
    for (var i = 0; i < tasks.length; i++) {
      result.push(await tasks[i]);
    }
    return result;
  },
  async Delay(ms) {
    return new Promise((reslove, reject) => {
      setTimeout(() => {
        reslove()
      }, ms)
    });
  }
}

export default {
  http: http,
  install(Vue, options) {
    Vue.prototype.$promission = http;
  }
}



// WEBPACK FOOTER //
// ./src/utils/promission_request.js